import React from "react";
import {
  Dialog,
  DialogActions,
  Divider,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  makeStyles,
  Button,
  TextareaAutosize,
  CircularProgress,
} from "@material-ui/core";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  categoryModal: {
    minWidth: 400,
  },
  modalTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
  },
  btn: {
    borderRadius: "10px",
    padding: theme.spacing(1, 4),
    color: "#FFFFFF",
  },
  titleHead: {
    fontWeight: "bold",
    fontSize: "1rem",
  },

  cancelBtn: {
    background: "linear-gradient(90.49deg, #373738 -0.38%, #565656 99.9%)",
    "&:hover": {
      background: "linear-gradient(90.49deg, #2c2c2d -0.38%, #484848 99.9%)",
    },
    border: "1px",
  },
  rejectBtn: {
    background: "linear-gradient(90deg, #A21717 0%, #A91067 100%);",
  },
  header: {
    padding: theme.spacing(3, 4),
    minHeight: theme.spacing(8),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "1.5rem",
    color: theme.palette.text.primary,
  },
  textAreaInput: {
    padding: theme.spacing(1, 2),
    borderRadius: "0.5rem",
    width: "100%",
    fontFamily: "Roboto",
    fontSize: "1rem",
  },
  actionButtons: {
    padding: theme.spacing(3, 4),
  },
  listItem: {
    fontSize: "1.5rem",
  },
}));

const ConfirmDelete = ({
  openDialog,
  onClose,
  onApproveOrReject,
  reasonForReject,
  setReasonForReject,
  isDeleteModalLoading,
}) => {
  const classes = useStyles();

  const handleCancel = () => {
    onClose();
  };
  const cleaneValue = (e) => {
    const rawValue = e.target.value;
    let cleanedValue = rawValue.replace(/\s{2,}/g, " ");
    if (cleanedValue.startsWith(" ")) {
      cleanedValue = cleanedValue.trimStart();
    }
    return cleanedValue;
  };

  return (
    <Dialog fullWidth open={openDialog} onClose={() => onClose()}>
      <div className={classes.header}>
        <Grid
          container
          style={{ justifyContent: "space-between" }}
          alignItems="center"
          spacing={4}
        >
          <Grid item>
            <Typography
              className={classes.title}
              variant="h4"
              id="upload-document-modal"
            >
              Confirm Reject
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleCancel} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </div>
      <Divider />

      <DialogContent className={classes.categoryModal}>
        <Typography className={classes.titleHead} variant="h6">
          Reason For Reject
        </Typography>
        <TextareaAutosize
          id="outlined-basic"
          fullWidth
          required
          value={reasonForReject}
          placeholder="Please Enter here"
          className={classes.textAreaInput}
          onChange={(e) => {
            const textAreaValue = cleaneValue(e)
            setReasonForReject(textAreaValue);
          }}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <div className={classes.actionButtons}>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                onClick={handleCancel}
                color="default"
                className={[classes.btn, classes.cancelBtn]}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={() => onApproveOrReject("reject")}
                color="primary"
                variant="contained"
                disableElevation
                disabled={reasonForReject === "" || isDeleteModalLoading}
                className={[classes.btn, classes.rejectBtn]}
              >
                {isDeleteModalLoading ? <CircularProgress size={24} /> : "Confirm"}
              </Button>
            </Grid>
          </Grid>
        </div>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDelete.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApproveOrReject: PropTypes.func.isRequired,
  reasonForReject: PropTypes.any,
  setReasonForReject: PropTypes.func,
  isDeleteModalLoading: PropTypes.bool,
};

export default ConfirmDelete;